import React from 'react';
import PropTypes from 'prop-types';
import './BillSummaryGrid.css';

const fmtMoney = (n) =>
  Number(n || 0).toLocaleString('es-PE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const fmtCount = (n) =>
  Number(n || 0).toLocaleString('es-PE', {
    maximumFractionDigits: 0,
  });

const BillingSummaryByDocumentGrid = ({ rows = [], electronicTotal }) => {
  if (!rows || rows.length === 0) return null;

  return (
    <div className="billing-grid">
      <div className="grid-header-bar">
        <div className="grid-title">
          GESTIÓN DE VENTAS E INGRESOS ELECTRÓNICOS
        </div>
      </div>

      <div className="grid-wrapper">
        <table className="billing-table">
          <thead>
            <tr className="grid-header">
              <th className="cell desc">Tipo de Documento</th>
              <th className="cell num">Total Documentos</th>
              <th className="cell num">
                Base imponible de la operación gravada
              </th>
              <th className="cell num">Monto Total del IGV</th>
              <th className="cell num">
                Importe total de la operación Gravada
              </th>
              <th className="cell num">
                Importe total de la operación exonerada
              </th>
              <th className="cell num">Total CP</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((r, idx) => (
              <tr
                className={`grid-body ${idx % 2 === 1 ? 'alt' : ''}`}
                key={`${r.documentCode}-${r.description}`}
              >
                <td className="cell desc">{r.description}</td>
                <td className="cell num">{fmtCount(r.documentCount)}</td>
                <td className="cell num">{fmtMoney(r.taxableAmount)}</td>
                <td className="cell num">{fmtMoney(r.taxAmount)}</td>
                <td className="cell num">{fmtMoney(r.netAmount)}</td>
                <td className="cell num">{fmtMoney(r.exemptAmount)}</td>
                <td className="cell num">{fmtMoney(r.totalAmount)}</td>
              </tr>
            ))}

            {electronicTotal && (
              <tr className="grid-total">
                <td className="cell desc">{electronicTotal.description}</td>
                <td className="cell num">
                  {fmtCount(electronicTotal.documentCount)}
                </td>
                <td className="cell num">
                  {fmtMoney(electronicTotal.taxableAmount)}
                </td>
                <td className="cell num">
                  {fmtMoney(electronicTotal.taxAmount)}
                </td>
                <td className="cell num">
                  {fmtMoney(electronicTotal.netAmount)}
                </td>
                <td className="cell num">
                  {fmtMoney(electronicTotal.exemptAmount)}
                </td>
                <td className="cell num">
                  {fmtMoney(electronicTotal.totalAmount)}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

BillingSummaryByDocumentGrid.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      documentCode: PropTypes.string,
      description: PropTypes.string,
      documentCount: PropTypes.number,
      documentCountSucess: PropTypes.number,
      documentCountError: PropTypes.number,
      exemptAmount: PropTypes.number,
      taxableAmount: PropTypes.number,
      taxAmount: PropTypes.number,
      netAmount: PropTypes.number,
      totalAmount: PropTypes.number,
    }),
  ),
  electronicTotal: PropTypes.shape({
    documentCode: PropTypes.string,
    description: PropTypes.string,
    documentCount: PropTypes.number,
    documentCountSucess: PropTypes.number,
    documentCountError: PropTypes.number,
    exemptAmount: PropTypes.number,
    taxableAmount: PropTypes.number,
    taxAmount: PropTypes.number,
    netAmount: PropTypes.number,
    totalAmount: PropTypes.number,
  }),
};

BillingSummaryByDocumentGrid.defaultProps = {
  rows: [],
  electronicTotal: null,
};

export default BillingSummaryByDocumentGrid;
